import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid, Popover,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Carousel from "react-material-ui-carousel";
import React, {useEffect, useState} from "react";
import Skelet from "../Skelet";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDatabase } from "../../contexts/DatabaseContext";
import { Button } from "@material-ui/core";
import {Link} from "react-router-dom";
import {useLocation} from "react-router";
import {db} from "../../firebase";


const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  width: "35.5vh",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}



function Prizes(props) {
  const { prizes, uid, currentUser } = props;
  const [isOpen, setOpen] = useState(false);
  const [success, setSuccess] = useState(true);
  const [selected, setSelected] = useState(null);
  const [link, setLink] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
  let data = <Skelet />;
  let query = useQuery();

  async function purchasePrize(userId, prizeId) {

    db.doc(`users/${userId}`).get().then((user) => {
      db.doc(`prizes/${prizeId}`).get().then((prize) => {
        if (user.data().points >= prize.data().price) {
          let received = false;
          const junctionRef = db.collection(`purchases`);
          junctionRef.add({
            userId,
            prizeId,
            received,
          }).then(() => {
            let points = user.data().points - prize.data().price;
            db.doc(`users/${userId}`).set({ points }, { merge: true });
          });
          setSuccess(true)
        } else {
          setSuccess(false);
        }
      })
    })

  }

  useEffect(() => {
    if (query.get("id") !== null) {
      setLink("?id="+query.get("id"));
    } else {
      setLink("");
    }

  }, [query]);

  const handleOpen = (doc) => {
    setOpen(true);
    setSelected(doc);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleBuy = (doc, event) => {
    purchasePrize(uid, doc.id).then(() => {
      setAnchorEl(event.currentTarget);
    });

  };

  const handleClosePopup = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => setOpen(false);
  const renderBuyPage = () => {
    let { name, image, price } = selected.data();

    return (
      <Box
        noValidate
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ height: 300, width: 250, margin: 2, borderRadius: 5 }}
          component="img"
          src={image}
        />
        <Typography sx={{ mt: 2 }} variant="h5">
          {name}
        </Typography>
        <Typography sx={{ mt: 1 }}>Цена: {price} баллов</Typography>
        <Button
          onClick={handleBuy}
          style={{ marginTop: 20 }}
          variant="contained"
          color="primary"
        >
          Получить
        </Button>
      </Box>
    );
  };

  let renderPrizes = (docs) => {
    return docs.map((doc, i) => {
      return (
        <Card key={i}>
          <CardMedia
            component="img"
            alt={doc.data().name}
            height="300px"
            image={doc.data().image}
          />
          {(uid !== currentUser.uid) ? (
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                {doc.data().name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {doc.data().price} баллов
              </Typography>
            </CardContent>
          ) : (

              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {doc.data().name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {doc.data().price} баллов
                </Typography>
                <Grid sx={{ marginTop: 2 }} container justifyContent="center">

                  <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClosePopup}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                  >
                    <Typography sx={{ p: 1 }}>{success ? "Получено" : "Не хватает баллов"}</Typography>
                  </Popover>
                </Grid>
              </CardContent>

          )}

        </Card>
      );
    });
  };

  try {
    if (prizes !== null) {
      data = (
        <Box sx={{ width: 250 }}>
          <Carousel interval={10000}>{renderPrizes(prizes)}</Carousel>
        </Box>
      );
    }
  } catch {}

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography fontFamily="Mossport" sx={{ fontSize: 25 }} color="text.secondary" gutterBottom>
          ПРИЗЫ
        </Typography>
        <Grid sx={{ marginTop: 3 }} container justifyContent="center">
          {data}
        </Grid>
        <Grid sx={{ marginTop: 2 }} container justifyContent="center">
          <Button component={Link} to={"/purchases" + link} variant="outlined">Мои призы</Button>
        </Grid>

      </CardContent>


    </Card>
  );
}

Prizes.propTypes = {
  prizes: PropTypes.any,
  uid: PropTypes.any,
  currentUser: PropTypes.any,
};

export default Prizes;
